import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Initiative } from '../models/initiative';
import { extractErrorMessage } from '../utils/utils';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InitiativeService {
  baseUrl: string = environment.api_url;
  constructor(private readonly http: HttpClient) { }

  // GET all initiatives
  getAllInitiatives(): Observable<Initiative[]> {
    return this.http.get<Initiative[]>(`${this.baseUrl}/initiatives`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET single initiative by ID
  getInitiativeById(id: number): Observable<Initiative> {
    return this.http.get<Initiative>(`${this.baseUrl}/initiatives/${id}`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET all initiatives
  getSortedInitiatives(sortBy: string): Observable<Initiative[]> {
    return this.http.get<Initiative[]>(`${this.baseUrl}/initiatives?sort=${sortBy}`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  create(initiative: Omit<Initiative, 'id'> & { id: number | null }): Observable<Initiative> {
    return this.http.post<Initiative>(`${this.baseUrl}/initiatives`, initiative).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
  
  update(initiative: Initiative): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/initiatives/${initiative.id}`, initiative).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/initiatives/${id}`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
}
